import { Col, Row } from '@design-system/components/grid/grid';
import { TextInput } from '../../../promotions/view/components/TextInput';
import * as s from '../pdf/form.css';
import { Typography } from '@design-system/components/typography/typography';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { extrasVM } from '../Extras.page';
import { BannerImage } from '../components/BannerImage';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import { Textarea } from '@design-system/components/textarea/textarea';
import { Controller } from 'react-hook-form';
import { Desc } from '@client/new/pages/promotions/view/components/FormTypography';
import { Button } from '@design-system/components/button/button';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { Player } from '@client/new/common/videos/Player';
import { getPoster } from './video.mappers';
import { ExtrasFormHeader } from '../components/ExtrasFormHeader';

export const VideoForm = () => {
  const p = extrasVM.useValue().videoVM;

  return (
    <div>
      <Col data-testid="ContentVideoForm" gap="xl" className={s.wrapper}>
        <ExtrasFormHeader
          content={{
            type: 'ContentVideo',
            value: p.content,
          }}
        />

        <Row>
          <Col>
            <Row>
              <Typography variant="body" size="large" fontWeight="medium">
                Video file
              </Typography>
            </Row>
            <Desc>Upload video file.</Desc>
          </Col>
          <Col>
            <div className={s.alignRight}>
              <Button
                color="primary"
                variant="text"
                size="medium"
                onClick={() => {
                  p.dispatch('PrepareReupload');
                }}
              >
                Replace
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="rounded-[10px] w-[174px] h-[249px] bg-black relative">
            <Player
              src={
                p.content.muxPlaybackId
                  ? `https://stream.mux.com/${p.content.muxPlaybackId}.m3u8`
                  : ''
              }
              poster={getPoster(p.content)}
              duration={(p.content?.durationMs || 0) / 1000}
              height={249}
              width={174}
            />
          </Col>
        </Row>
        <Row>
          <Button
            variant="text"
            color="neutral"
            onClick={() => {
              p.dispatch('PrepareThumbnail');
            }}
            leftIcon={faPencil}
            className="w-[125px]"
          >
            Thumbnail
          </Button>
        </Row>

        <BannerImage
          imageUrl={p.values.coverURL}
          onChange={(url) => p.onChange('coverURL', url)}
          optionality
          defaultState={!!p.values.coverURL}
        />

        <Row className={s.divider}>
          <Col gap="xl">
            <TextInput
              label="Title"
              description="This title will be shown to your users"
              {...p.register('title')}
              required
            />
            <Controller
              name="description"
              control={p.control}
              render={({ field, fieldState: { error } }) => (
                <Textarea
                  {...field}
                  error={error?.message}
                  onBlur={(e) => p.onChange('description', e.target.value)}
                  label="Description"
                  rows={4}
                />
              )}
            />
          </Col>
        </Row>

        <Col className={s.divider}>
          <Row>
            <Typography variant="body" size="large" fontWeight="medium">
              Allow comments
            </Typography>

            <Toggle
              value={p.values.allowComments}
              onChange={() =>
                p.onChange('allowComments', !p.values.allowComments)
              }
            />
          </Row>
          <Row>
            <Desc>
              Toggle off to turn off the comments on your video. Comments will
              be turned off for all users. Existing comments remain visible to
              you for future reference.
            </Desc>
          </Row>
        </Col>
      </Col>
    </div>
  );
};
